<div class="container" *ngIf="!isLoading; else loadingTpl">
  <mat-card *ngIf="invitation as inv; else notFoundTpl">
    <mat-card-title>
      Convite para condomínio {{ inv.condominium.name }}
    </mat-card-title>
    <mat-card-content>
      <p>
        Você foi convidado a fazer parte do condomínio {{ inv.condominium.name }}
      </p>

      <ng-container *ngIf="!isExpired; else expiredTpl">
        <p>
          Expira em: {{ inv.expirationTime | date:'short' }}
        </p>
      </ng-container>

      <ng-template #expiredTpl>
        <p class="mat-warn">Este convite expirou.</p>
      </ng-template>
    </mat-card-content>

    <mat-card-actions *ngIf="!isExpired; else backOnlyTpl">
      <button mat-raised-button color="primary" (click)="onAccept()">Aceitar</button>
      <button mat-stroked-button color="warn" (click)="onReject()">Rejeitar</button>
    </mat-card-actions>

    <ng-template #backOnlyTpl>
      <mat-card-actions>
        <button mat-stroked-button color="primary" (click)="onBack()">Voltar</button>
      </mat-card-actions>
    </ng-template>
  </mat-card>
</div>

<ng-template #loadingTpl>
  <div class="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
  </div>
  
</ng-template>

<ng-template #notFoundTpl>
  <mat-card>
    <mat-card-title>Convite não encontrado</mat-card-title>
    <mat-card-actions>
      <button mat-stroked-button color="primary" (click)="onBack()">Voltar</button>
    </mat-card-actions>
  </mat-card>
</ng-template>
